import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { normalizeRoleName } from 'permission';
import type { CurrentUserPayload, Role, User } from './types';

export interface AuthorizeState {
  user: User | null;
  permissionAssigned: boolean;
}

export const initialState: AuthorizeState = {
  user: null,
  permissionAssigned: false,
};

const authorizeSlice = createSlice({
  name: 'authorize',
  initialState,
  reducers: {
    setCurrentUserData(state, { payload }: PayloadAction<CurrentUserPayload>) {
      const roles: Role[] = payload.roles.map(role => ({ ...role, name: normalizeRoleName(role.name) as string }));
      const resolved: Role | undefined = roles.find(({ pk }) => pk === payload.active_role);
      state.user = { ...payload, roles, active_role: resolved };
    },
    setPermissionAssigned(state, { payload }: PayloadAction<boolean>) {
      state.permissionAssigned = payload;
    },
    resetAuthorizeReducer(_state) {
      _state = initialState;
    },
  },
});

export const { setCurrentUserData, setPermissionAssigned, resetAuthorizeReducer } = authorizeSlice.actions;
export default authorizeSlice.reducer;
